import React from 'react';
import {
	CancellationData,
	withCancellationContext,
} from '../../../context/CancellationProvider';
import {
	BREADCRUMB__INVOICE,
	BREADCRUMB__INVOICES,
} from '../../../data/labelsAndMessages';
import { useRouteMatch } from '../../../util/useRouteMatch';
import BreadcrumbsContainer, { Breadcrumb } from '../../BreadcrumbsContainer';
import LargeCenterSpinner from '../../LargeCenterSpinner';
import {
	AcceptedReinstatementRoutes,
	ACCEPTED_REINSTATEMENT_ROUTES,
} from '../Sidebar/AcceptedReinstatementSidebar';

interface Props {
	cancellationData: CancellationData;
}

const Breadcrumbs = (props: Props) => {
	const { policy, selectedCancellation } = props.cancellationData;
	const routeMatch = useRouteMatch(
		Object.keys(ACCEPTED_REINSTATEMENT_ROUTES).map(
			(key) =>
				ACCEPTED_REINSTATEMENT_ROUTES[key as keyof AcceptedReinstatementRoutes],
		),
	);
	const params = routeMatch?.params || {};
	const routeName = routeMatch?.pattern?.path || '';

	if (!policy || !selectedCancellation) {
		return <LargeCenterSpinner />;
	}

	const { policyholderLocator, locator } = policy;

	const breadcrumbs: Breadcrumb[] = [
		{ href: `/policyholder/${policyholderLocator}`, text: 'Policyholder' },
		{ href: `/policy/${locator}`, text: `Policy ${locator}` },
		{
			href: `/policy/${locator}/cancellations/${selectedCancellation.locator}`,
			text: `Cancellation ${selectedCancellation.locator}`,
		},
		{
			href: null,
			text: `Reinstatement ${selectedCancellation.reinstatement.locator}`,
		},
	];

	// prepare invoices breadcrumbs
	if (
		[
			ACCEPTED_REINSTATEMENT_ROUTES.INVOICE,
			ACCEPTED_REINSTATEMENT_ROUTES.INVOICES,
		].includes(routeName)
	) {
		breadcrumbs.push({
			href: ACCEPTED_REINSTATEMENT_ROUTES.INVOICES.replace(
				':policyId',
				policy.locator,
			)
				.replace(':cancellationId', selectedCancellation.locator)
				.replace(
					':reinstatementId',
					selectedCancellation.reinstatement.locator,
				),
			text: BREADCRUMB__INVOICES(),
		});

		if (routeName === ACCEPTED_REINSTATEMENT_ROUTES.INVOICE) {
			breadcrumbs.push({
				href: ACCEPTED_REINSTATEMENT_ROUTES.INVOICE.replace(
					':policyId',
					policy.locator,
				)
					.replace(':cancellationId', selectedCancellation.locator)
					.replace(
						':reinstatementId',
						selectedCancellation.reinstatement.locator,
					)
					.replace(':invoiceId', params?.invoiceId),
				text: BREADCRUMB__INVOICE(params.invoiceId),
			});
		}
	}

	return <BreadcrumbsContainer breadcrumbs={breadcrumbs} />;
};

export default withCancellationContext<Props>(Breadcrumbs);
